<template>
  <div class="FindUserId">
    <div class="FindUserId__container">
      <!-- CLOSE -->
      <div class="FindUserId__close">
        <router-link to="/login">
          <img
            width="28px"
            src="@/assets/img/login/ic_back_btn.png"
            alt="아이디 찾기 모달 닫기"
          />
        </router-link>
        <div>아이디 찾기</div>
        <img
          width="28px"
          src="@/assets/img/login/ic_modal_close.png"
          alt="아이디 찾기 모달 닫기"
        />
      </div>
      <div class="FindUserId__contents">
        <!-- TITLE -->
        <div class="FindUserId__contents__header">
          기본 정보를 입력한 후 휴대폰 인증을<br />
          진행해 주세요.
        </div>
        <!-- FORM -->
        <div
          v-for="(user, index) in userDataForm"
          :key="`${user.type}-${index}`"
          class="FindUserId__contents__items"
        >
          <div class="FindUserId__contents__items__title">
            {{ user.title }}
            <span v-if="user.requrid">(필수)</span>
          </div>
          <div class="FindUserId__contents__items__form">
            <div
              v-if="user.type === 'name'"
              class="FindUserId__contents__items__name"
            >
              <input
                v-model="user.value"
                type="text"
                maxlength="10"
                :placeholder="user.placeholder"
              />
            </div>
            <div
              v-if="user.type === 'userNumber'"
              class="FindUserId__contents__items__user-number"
            >
              <input
                v-model="user.value.birth"
                type="number"
                pattern="\d*"
                maxlength="6"
                class="user-number"
                :placeholder="user.placeholder"
              />
              <span>-</span>
              <input
                v-model="user.value.gender"
                maxlength="1"
                pattern="\d*"
                type="number"
                class="gender"
              />
              <span>******</span>
            </div>
            <div
              v-if="user.type === 'phone'"
              class="FindUserId__contents__items__phone"
            >
              <button
                type="button"
                @click="handlePhoneCertification"
                :disabled="isPhoneNumberDisabled || isCompleteCertification"
              >
                휴대폰 인증
              </button>
            </div>
          </div>
        </div>

        <!-- CHECK ID -->
        <template v-if="isNotFoundId">
          <div class="FindUserId__result__button error">
            <span>인증정보와 일치하는 ID가 존재하지 않습니다.</span>
          </div>
          <div class="FindUserId__result__reset">
            <span @click="handleReset">아이디 다시찾기</span>
          </div>
        </template>

        <!-- CHECK ID -->
        <div v-else-if="userId !== ''" class="FindUserId__result__button">
          <span class="user-id">{{ userId }}</span>
        </div>

        <!-- SUBMIT -->
        <button
          v-else
          class="FindUserId__result__button"
          @click="handleCheckUerId"
          :disabled="!isPhoneCertification"
        >
          <span>아이디 확인</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";
import Masking from "@/common/masking.js";

export default {
  name: "FindUserId",
  data() {
    return {
      userDataFormModel: [
        {
          type: "name",
          title: "이름",
          requrid: true,
          has_error: false,
          placeholder: "이름",
          value: "",
        },
        {
          type: "userNumber",
          title: "주민등록번호",
          requrid: true,
          has_error: false,
          placeholder: "주민등록번호 앞 6자리",
          value: {
            birth: "",
            gender: "",
          },
        },
        {
          type: "phone",
          title: "휴대폰 인증",
          requrid: false,
          has_error: false,
          placeholder: "",
          value: "",
        },
      ],
      userDataForm: [],
      isPhoneCertification: false,
      isCompleteCertification: true,
      userId: "",
      isNotFoundId: false,
      userData: null,
    };
  },
  computed: {
    isPhoneNumberDisabled() {
      const error = [];

      this.userDataForm.forEach((user) => {
        if (
          (user.type === "name" && user.value === "") ||
          (user.type === "userNumber" && user.value.birth === "") ||
          user.value.gender === ""
        ) {
          error.push(user.type);
        }
      });

      if (!error.length) {
        this.isCompleteCertification = false;
      }

      return error.length > 0;
    },
  },
  created() {
    document.domain = "flybit.com";
    // window.sendResult = this.handleRecieveResult;
    this.handleReset();
  },
  beforeDestroy() {
    document.domain = window.location.hostname;
  },
  methods: {
    async handlePhoneCertification() {
      const formData = {};

      this.userDataForm.forEach((form) => {
        if (form.type === "name") {
          formData.name = form.value;
        }

        if (form.type === "userNumber") {
          formData.birth = String(form.value.birth);
          formData.genderNum = String(form.value.gender);
        }
      });

      window.open(
        `${Api.Comm.url}/auth/nice/view/email/W?name=${formData.name}&birth=${formData.birth}&genderNum=${formData.genderNum}`,
        "chkPopup",
        "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no",
      );
    },
    handleCheckUerId() {
      this.userData
        ? (this.userId = Masking.emailMasking(this.userData))
        : (this.isNotFoundId = true);
    },
    handleRecieveResult(isCertification = false, userData = null) {
      this.isPhoneCertification = isCertification;
      this.isCompleteCertification = true;
      this.isNotFoundId = false;

      this.isPhoneCertification
        ? (this.userData = userData)
        : (this.isNotFoundId = true);
    },
    handleReset() {
      this.userDataForm = _.cloneDeep(this.userDataFormModel);
      this.isNotFoundId = false;
      this.isPhoneCertification = false;
    },
    handleOnlyNumber(event, type) {
      this.userDataForm.forEach((form) => {
        if (form.type === "userNumber") {
          console.log(type, form.value[type]);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.FindUserId {
  box-sizing: border-box;

  &__close {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 33px;
    border-bottom: 1px solid #eef0f3;

    img {
      cursor: pointer;
      opacity: 0;

      &:first-child {
        opacity: 1;
      }

      &:hover {
        opacity: 0.5;
      }
    }
  }

  &__container {
    background: #fff;
  }

  &__contents {
    padding: 20px 33px;

    &__header {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      margin-bottom: 20px;
    }

    &__items {
      margin-top: 12px;

      &__title {
        margin-bottom: 7px;
        font-size: 12px;
        color: #333;

        span {
          color: #eb3246;
        }
      }

      &__form {
        flex: 1;

        input {
          box-sizing: border-box;
          font-family: "Spoqa Han Sans", "Noto Sans KR", sans-serif;
          height: 38px;
          line-height: normal !important;
          vertical-align: middle;
          display: flex;
          align-items: center;
          width: 100%;
          border: 1px solid #dcdfe3;
          border-radius: 2px;
          padding: 9px;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;

          &::-webkit-input-placeholder {
            display: flex;
            align-items: center;
            font-size: 12px;
            text-transform: uppercase;
            color: #afafaf;
            font-weight: 400;
            vertical-align: middle;
            line-height: normal !important;
          }

          &:active,
          &:focus {
            border-color: #333;
          }
        }

        button {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          background: #00b473;
          border-radius: 4px;

          &:disabled {
            cursor: not-allowed;
          }
        }
      }

      &__user-number {
        display: flex;
        align-items: center;

        .user-number {
          flex-basis: 150px;
          width: 150px;
          flex-shrink: 0;
        }

        .gender {
          flex-basis: 38px;
          width: 38px;
          flex-shrink: 0;
          text-align: center;
        }

        span {
          color: #333;
          font-size: 12px;
          margin: 0 5px;
        }
      }
    }
  }

  &__result__button {
    margin-top: 44px;
    height: 66px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #98e0c6;
    border-radius: 4px;
    color: #00b473;

    font-size: 12px;
    font-weight: 500;

    &.error {
      border-color: #f8c0c6;
      color: #eb3246;
      font-weight: normal;
      text-decoration: none;
    }

    &:disabled {
      background: #fff !important;
      border-color: #afafaf;
      color: #afafaf !important;
      text-decoration: none;
      cursor: not-allowed;

      span {
        text-decoration: none;
      }
    }

    span {
      text-decoration: underline;
    }

    .user-id {
      color: #333;
      font-weight: 500;
      text-decoration: none;
    }
  }
  &__result__reset {
    font-size: 16px;
    color: #333;
    text-decoration: underline;
    margin-top: 20px;
    text-align: center;

    span {
      cursor: pointer;
    }
  }
}
</style>
